<template>
  <div class="register business-open-content">
    <div class="register-data-content">
      <component :registerInfo="registerInfo" :businessNames="businessNames" @clickNext="onNextClick" :is="componentName"></component>
    </div>
  </div>
</template>

<script>
import registerBasic from './register-basic.vue'
import newCompany from './new-company.vue'
import { qryComByPhone } from '@/api/register-shop'
export default {
  components: {
    registerBasic,
    newCompany
  },
  name: "registerIndex",
  data () {
    return {
      registerInfo: {},
      businessNames: [],
      componentName: 'registerBasic'
    }
  },
  computed: {
    reload () {
      return this.$store.state.app.reload
    },
    userRegisterInfo () {
      return this.$store.state.app.userRegisterInfo
    }
  },
  mounted () {
    console.log(this.userRegisterInfo, 'userRegisterInfo')
    this.mountedFn()
  },
  beforeRouteLeave(to, from, next) {
    this.deleteLoad()
    next()
  },
  methods: {
    mountedFn () {
      if (this.reload) {
        this.deleteLoad()
        this.$router.replace('/business-open-shop/ready-data')
        return false
      }
      if (this.userRegisterInfo.phone) {
        // qryComByPhone({ phone: this.userRegisterInfo.phone, isShowLoading: true }).then(res => {
        //   this.componentName = 'newCompany'
        //   this.businessNames = res.data.data
        //   this.registerInfo = this.userRegisterInfo
        // })
      }
      this.$store.commit('RELOAD_SET', true)
      // sessionStorage.setItem('closeWindow', 'true')
    },
    deleteLoad() {
      window.removeEventListener('beforeunload', e => this.onbeforeunload(e))
    },
    onbeforeunload(e) {
      e = e || window.event
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        e.returnValue = '关闭提示'
      }
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return '关闭提示'
    },
    onNextClick (res) {
      console.log(res, '撒旦法')
      this.componentName = 'newCompany'
      this.businessNames = res.businessNames
      this.registerInfo = res.registerInfo
    }
  }
}
</script>

<style scoped lang="scss">
.register {
  display: flex;
  justify-content: center;
  padding-top: 42px;
  min-height: calc(100vh - 290px) !important;
  height: auto !important;
  padding-bottom: 20px;
  .register-data-content {
    width: 500px;
  }
}
.business-open-content{
  margin-top: 20px;
}
</style>
